<template>
  <div>
    <MainProjects />
  </div>
</template>

<script>
import MainProjects from "@/components/MainProjects/index.vue";
export default {
  components: {
    MainProjects,
  },
};
</script>

<style></style>
